import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ActivityResourcesPage } from "src/components/views/erp/project/projectActivity/activityResources/ActivityResourcesPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/activityResources")({
	staticData: { title: i18n.t("activity_resources"), legacyViewKey: "activityResourcesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ActivityResourcesPage />;
}
